var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwygsbotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1354 12.3352C11.1354 12.7185 11.2358 13.0196 11.4343 13.2355C11.635 13.4498 11.8954 13.557 12.2191 13.557C12.6651 13.557 13.0568 13.443 13.3956 13.2113L14.64 16.8329C13.8574 17.2766 12.7873 17.5 11.435 17.5C9.66762 17.5 8.30775 17.0751 7.35387 16.2216C6.39999 15.3681 5.92456 14.0875 5.92456 12.382V10.5459C5.92456 9.35959 6.88598 8.39817 8.07229 8.39817H9.72649C10.2653 8.39817 10.7566 8.18762 11.1188 7.8435C11.1309 7.83142 11.1445 7.81784 11.1588 7.80577C11.5248 7.4375 11.7512 6.93339 11.7512 6.37344C11.7512 5.81349 11.5075 5.26939 11.1188 4.89961C10.7558 4.55549 10.2653 4.34645 9.72649 4.34645H8.07229C6.88598 4.34645 5.92456 3.38503 5.92456 2.19872V0.5H11.1188V1.86139C11.1188 3.23334 12.2297 4.34645 13.6039 4.34645C14.1601 4.34645 14.6823 4.57435 15.0641 4.94111C15.4475 5.30712 15.6897 5.81349 15.6912 6.37042C15.6912 6.93188 15.4648 7.43825 15.0951 7.80652C14.7306 8.17253 14.2227 8.39892 13.6627 8.39892H13.6348C12.2614 8.39892 11.1498 9.51203 11.1498 10.884L11.1362 12.3359L11.1354 12.3352Z",
    fill: "#204A22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45748 8.45024C5.6103 8.45024 6.54484 7.51569 6.54484 6.36287C6.54484 5.21006 5.6103 4.27551 4.45748 4.27551C3.30466 4.27551 2.37012 5.21006 2.37012 6.36287C2.37012 7.51569 3.30466 8.45024 4.45748 8.45024Z",
    fill: "#204A22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwygsbotIcon);
export default __webpack_public_path__ + "static/media/twygsbot-icon.b1324bd3cacbb349d45ce32753124b2c.svg";
export { ForwardRef as ReactComponent };